import { Alert, Button, Modal, Stack } from "@assetwatch/ui";

type CancelRequestDialogProps = {
  error: string | null;
  isPending: boolean;
  onConfirm: () => void;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  requestNumber: string;
  requestTitle: string;
};

export function CancelRequestDialog({
  error,
  isPending,
  onConfirm,
  onOpenChange,
  open,
  requestNumber,
  requestTitle,
}: CancelRequestDialogProps) {
  return (
    <Modal
      dismissible={!isPending}
      footer={
        <>
          <Button
            disabled={isPending}
            onClick={() => onOpenChange(false)}
            variant="ghost"
          >
            Keep request
          </Button>
          <Button
            intent="destructive"
            loading={isPending}
            loadingText="Cancelling request"
            onClick={onConfirm}
          >
            Cancel request
          </Button>
        </>
      }
      onOpenChange={onOpenChange}
      open={open}
      title="Cancel request?"
    >
      <Stack gap={16}>
        <p className="font-(family-name:--font-family-body) text-(length:--font-size-body-medium) leading-(--font-line-height-20) text-text-subtle">
          Cancelling{" "}
          <strong className="font-(family-name:--font-family-label) font-(number:--font-weight-semibold) text-text-default">
            {requestNumber}
          </strong>{" "}
          {"—"} {requestTitle}. The request will be marked Canceled and cannot
          be undone.
        </p>
        {error ? <Alert tone="negative" title={error} /> : null}
      </Stack>
    </Modal>
  );
}
